import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
class Skills extends React.Component {
  render() {
    return (
      <div className="skillscontainer">
        <div className="skills">
          <div className="skillsa">
            <h1 className="skillshead" id="skillsid">
              Skills
            </h1>
            <br />
            <ul className="skillslist">
              <li>UI UX Design with Figma</li>
              <li>HTML</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>React</li>
              <li>Github</li>
              <li>Agile methodology</li>
            </ul>
          </div>
          <div className="skillsb">
            <h1>Certifications</h1>
            <br />
            <ul className="certificationslist">
              <li>
                UI UX Design with Figma course completed in 2023 offered by
                Udemy
              </li>
              <li>HTML course completed in 2022 offered by Udemy</li>
              <li>CSS course completed in 2022 offered by Udemy</li>
              <li>Javascript course completed in 2022 offered by Udemy</li>
              <li>React course completed in 2022 offered by Udemy</li>
              <li>Agile course completed in 2022 offered by Cognizant</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default Skills;
